import React, { useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Context as RestaurantContext } from '../context/restaurant';
import { Context as AlertContext } from '../context/alert';
import { Context as AuthContext } from '../context/auth';
import MainLayout from '../layouts/mainLayout';
import TopBar from '../layouts/place/topBar';
import { initiatePayment } from '../api/payment';
import CheckoutTipsBill from '../features/checkout/components/tips/tipsBill';
import { useTableSseConnection } from '../hooks/useTableSseConnection';

const CheckoutTipsPage = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  useTableSseConnection();

  const { state: restaurantState } = useContext(RestaurantContext);
  const { alertController } = useContext(AlertContext);
  const { registerGuest } = useContext(AuthContext);

  const [initiating, setInitiating] = useState(false);
  const [paymentKey, setPaymentKey] = useState(null);

  const startPayment = async ({
    paymentType,
    tips,
    paymentMethodId,
    employeeId,
    dontDisable,
    paymentTrackId,
    paymentAccountId,
  }) => {
    if (!dontDisable) {
      setInitiating(true);
    }

    const { token } = await registerGuest();
    if (!token) {
      setInitiating(false);
      return;
    }

    const response = await initiatePayment({
      token,
      alertController,
      paymentType,
      restaurantType: restaurantState.restaurant.type,
      restaurantId: restaurantState.restaurant.id,
      tips,
      tableId: restaurantState.table.id,
      paymentMethodId,
      paymentAccountId,
      onlyTips: true,
      employeeId,
    });

    if (response && response.status === 'Created' && response.paymentLink) {
      // eslint-disable-next-line no-undef
      window.location.replace(response.paymentLink);
      return;
    }

    if (response && response.status === 'Created' && response.paymentKey) {
      if (paymentTrackId) {
        setPaymentKey(`${paymentTrackId}~${response.paymentKey || ''}`);
      } else {
        setPaymentKey(response.paymentKey);
      }

      return;
    }

    setInitiating(false);
  };

  return (
    <MainLayout showPayments>
      <div className="sticky top-0 bg-white z-10">
        <TopBar title={t('header.tips')} onBack={() => navigate('/')} />
      </div>
      <CheckoutTipsBill
        restaurant={restaurantState.restaurant}
        paymentOption={restaurantState.paymentOption}
        onPay={startPayment}
        onFail={() => {
          setPaymentKey(null);
          setInitiating(false);
          alertController.error({ text: t('errors.unknown') });
        }}
        paymentKey={paymentKey}
        disabled={initiating}
        onOpenMenu={() => {
          navigate('/menu');
        }}
      />
    </MainLayout>
  );
};

export default CheckoutTipsPage;
